export const STATUS_DRAFT = 'DRAFT';
export const STATUS_HIDDEN = 'HIDDEN';
export const STATUS_PUBLISHED = 'PUBLISHED';

export const STATUS_OPTIONS = [STATUS_DRAFT, STATUS_PUBLISHED].map((status) => ({
  key: status,
  text: status,
  value: status,
}));
